import * as React from 'react'
import * as LinkifyIt from 'linkify-it'
import tlds from 'tlds'

export const Linkify: React.FC<{}> = (props) => {
  return <>{parseString(props.children as string)}</>
}

Linkify.displayName = 'Linkify'

// PRIVATE HELPERS

const linkify = new LinkifyIt()
linkify.tlds(tlds)

const MATCH = (text: string): Array<any> => {
  return linkify.match(text)
}

function parseString(string: string) {
  if (typeof string !== 'string') {
    throw new Error('Linkify must contain raw string')
  }

  if (string === '') {
    return string
  }

  const matches = MATCH(string)
  if (!matches) {
    return string
  }

  const elements: (string | JSX.Element)[] = []
  let lastIndex = 0
  matches.forEach((match, i) => {
    if (match.index > lastIndex) {
      elements.push(string.substring(lastIndex, match.index))
    }

    elements.push(
      // eslint-disable-next-line react/no-array-index-key
      <a key={i} target="_blank" rel="noreferrer noopener" href={match.url}>
        {match.text}
      </a>
    )

    lastIndex = match.lastIndex
  })

  if (string.length > lastIndex) {
    elements.push(string.substring(lastIndex))
  }

  return elements.length === 1 ? elements[0] : elements
}
